import React from "react";
import { getFormattedNumber } from "../utils/textUtils";

const ReportStockClosing = ({ resPacket }) => {
    return resPacket?.length > 0 ? (
        <table className="customTable">
            <thead>
                <tr>
                    <td>SNO.</td>
                    <td>WAREHOUSE</td>
                    <td>ITEM</td>

                    <td>CURRENT STOCK PACKED</td>
                    <td>CURRENT STOCK LOOSE</td>
                    <td>TOTAL AVAILABLE STOCK</td>
                </tr>
            </thead>

            <tbody>
                {resPacket.map((a, i) => (
                    <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{a.warehouseTitle}</td>
                        <td>{a.itemTitle}</td>
                        <td>
                            {getFormattedNumber(a.currentStockBoxQuantity)}
                            &nbsp;{a.packUnitTitle}
                        </td>

                        <td>
                            {getFormattedNumber(a.currentStockOpenQuantity)}
                            &nbsp;{a.itemUnitTitle}
                        </td>
                        <td>
                            {getFormattedNumber(a.totalStockInOpenUnit)}
                            &nbsp;{a.itemUnitTitle}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    ) : (
        <>No Record found</>
    );
};

export default ReportStockClosing;
